
const InsertOutOfBoundsErrorMessage = 'Cannot insert items past the end of SparseList';

/**
 * Sparse list acts as a partial view of a list of data, used primarily for paginated query results.
 * Unlike an Array, SpareLists often contains many undefined entries. A SparseList's length property should
 * equal the total count of some persistent list (e.g. rows in a database table).
 */
export class SparseList<T> {

  private readonly _data: T[]; // tslint:disable-line:variable-name

  public constructor(
    length: number
  ) {
    this._data = Array<T>(length);
  }

  public get length(): number {
    return this._data.length;
  }

  public get data(): Readonly<T>[] {
    return this._data;
  }

  /**
   * Gets a single item from the list.
   * @param index index of item to get
   */
  public get(index: number): Readonly<T> {
    return this._data[index];
  }

  /**
   * Sets items in list within a range of indices, inclusive.
   * @param start beginning index, inclusive
   * @param end ending index of range, inclusive
   * @param data list of values to set
   */
  public setRange(start: number, data: T[]): void {
    for (let i = 0; i < data.length; i++) {
      const newIndex = start + i;
      if (newIndex < this._data.length) {
        this._data[start + i] = data[i];
      } else {
        throw new Error(InsertOutOfBoundsErrorMessage);
      }
    }
  }

  /**
   * Returns whether or not every item in a range is defined
   * @param start beginning index, inclusive
   * @param end ending index of range, inclusive
   */
  public rangeIsDefined(start: number, end: number): boolean {
    for (let i = start; i < end + 1; i++) {
      if (this._data[i] === undefined) {
        return false;
      }
    }

    return true;
  }
}
